import { render, staticRenderFns } from "./ManageChannelViewingSlots.vue?vue&type=template&id=eca355c4&"
import script from "./ManageChannelViewingSlots.vue?vue&type=script&lang=js&"
export * from "./ManageChannelViewingSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports